// import { axios } from "../helpers/axios";

// // Dummy data for Organizations Compliance
// const dummyOrgs = [
//   { id: 1, name: "Acme Corporation", msaSigned: true, lastAcceptedVersion: "25 May 2026, 18:45", complianceStatus: "Up-to-date", authorizedContact: "john.doe@acme.com" },
//   { id: 2, name: "Globex Corporation", msaSigned: true, lastAcceptedVersion: "24 May 2026, 12:30", complianceStatus: "Up-to-date", authorizedContact: "admin@globex.com" },
//   { id: 3, name: "Soylent Corp", msaSigned: true, lastAcceptedVersion: "20 May 2026, 09:15", complianceStatus: "Up-to-date", authorizedContact: "contact@soylent.com" },
//   { id: 4, name: "Initech", msaSigned: false, lastAcceptedVersion: "-", complianceStatus: "Pending", authorizedContact: "peter@initech.com" },
//   { id: 5, name: "Umbrella Corporation", msaSigned: false, lastAcceptedVersion: "15 May 2026, 16:00", complianceStatus: "Admin blocked", authorizedContact: "wesker@umbrella.com" },
//   { id: 6, name: "Veer Industries", msaSigned: true, lastAcceptedVersion: "25 May 2026, 10:10", complianceStatus: "Up-to-date", authorizedContact: "karan@veer.com" },
//   { id: 7, name: "Hooli Inc", msaSigned: false, lastAcceptedVersion: "-", complianceStatus: "Pending", authorizedContact: "gavin@hooli.com" },
// ];

// // Dummy data for Terms Repository
// let dummyTerms: any[] = [
//   { id: 1, version: "2026.05.01", title: "Customer Terms and Conditions", effectiveDate: "01 Jun 2026", changeType: "Material" as const, needsReacceptance: "Yes" as const, status: true, createdBy: "admin@livis.com", scenario: "Clickwrap", fileName: "terms_v1.pdf" },
//   { id: 2, version: "2026.04.15", title: "Customer Terms and Conditions", effectiveDate: "01 May 2026", changeType: "Material" as const, needsReacceptance: "Yes" as const, status: true, createdBy: "admin@livis.com", scenario: "Clickwrap", fileName: "terms_v2.pdf" },
//   { id: 3, version: "2026.02.10", title: "Customer Terms and Conditions", effectiveDate: "01 Mar 2026", changeType: "Minor" as const, needsReacceptance: "No" as const, status: true, createdBy: "admin@livis.com", scenario: "Browsewrap", fileName: "terms_v3.pdf" },
//   { id: 4, version: "2026.01.01", title: "Customer Terms and Conditions", effectiveDate: "15 Jan 2026", changeType: "Material" as const, needsReacceptance: "Yes" as const, status: true, createdBy: "admin@livis.com", scenario: "Clickwrap", fileName: "terms_v4.pdf" },
//   { id: 5, version: "2026.06.01", title: "Customer Terms and Conditions (Draft)", effectiveDate: "24 Jun 2026", changeType: "Material" as const, needsReacceptance: "Yes" as const, status: false, createdBy: "admin@livis.com", scenario: "Clickwrap", fileName: "terms_draft_v5.pdf" },
// ];

// export const getOrgComplianceAPI = async (filters: any) => {
//   // Commented API call:
//   // return axios.get(`/compliance/orgs/`, { params: filters });

//   // Filtering in dummy mode
//   let filtered = [...dummyOrgs];
//   if (filters.search) {
//     filtered = filtered.filter(
//       (org) =>
//         org.name.toLowerCase().includes(filters.search.toLowerCase()) ||
//         org.authorizedContact.toLowerCase().includes(filters.search.toLowerCase())
//     );
//   }
//   if (filters.msaFilter && filters.msaFilter !== "all") {
//     filtered = filtered.filter((org) =>
//       filters.msaFilter === "signed" ? org.msaSigned : !org.msaSigned
//     );
//   }
//   if (filters.statusFilter && filters.statusFilter !== "all") {
//     filtered = filtered.filter((org) => org.complianceStatus === filters.statusFilter);
//   }

//   return {
//     status: 200,
//     data: {
//       data: {
//         organizations: filtered,
//         total: filtered.length,
//       },
//     },
//   };
// };

// export const getTermsRepositoryAPI = async (filters: any) => {
//   // Commented API call:
//   // return axios.get(`/compliance/terms/`, { params: filters });

//   // Filtering in dummy mode
//   let filtered = [...dummyTerms];
//   if (filters.statusFilter && filters.statusFilter !== "all") {
//     filtered = filtered.filter((t) => {
//       const isDraft = (t.status as any) === false || (t.status as any) === "Draft";
//       if (filters.statusFilter === "draft") return isDraft;
//       if (filters.statusFilter === "active") return !isDraft;
//       return true;
//     });
//   }
//   if (filters.typeFilter && filters.typeFilter !== "all") {
//     filtered = filtered.filter((t) => t.changeType.toLowerCase() === filters.typeFilter.toLowerCase());
//   }

//   return {
//     status: 200,
//     data: {
//       data: {
//         terms: filtered,
//         total: filtered.length,
//       },
//     },
//   };
// };

// export const uploadPhysicalMsaAPI = async (payload: any) => {
//   // Commented API call:
//   // return axios.post(`/compliance/upload-msa/`, payload);

//   return {
//     status: 200,
//     data: {
//       message: "MSA uploaded successfully",
//     },
//   };
// };

// export const createNewTermsVersionAPI = async (payload: any) => {
//   // Commented API call:
//   // return axios.post(`/compliance/create-version/`, payload);

//   const newId = dummyTerms.length > 0 ? Math.max(...dummyTerms.map((t) => t.id)) + 1 : 1;
//   const newTerm = {
//     id: newId,
//     version: payload.version || "New Version",
//     title: payload.title || "Customer Terms and Conditions",
//     effectiveDate: payload.effectiveDate || new Date().toLocaleDateString(),
//     changeType: payload.changeType || "Material",
//     needsReacceptance: (payload.changeType === "Material" ? "Yes" : "No") as "Yes" | "No",
//     status: false, // New versions created are drafts by default (represented by status = false)
//     createdBy: "admin@livis.com",
//     scenario: payload.scenario || "Clickwrap",
//     fileName: payload.file ? payload.file.name : null,
//   };

//   dummyTerms = [newTerm, ...dummyTerms];

//   return {
//     status: 200,
//     data: {
//       message: "Terms version created successfully",
//       term: newTerm,
//     },
//   };
// };

// export const updateTermsVersionAPI = async (payload: any) => {
//   // Commented API call:
//   // return axios.put(`/compliance/terms/${payload.id}/`, payload);

//   dummyTerms = dummyTerms.map((t) => {
//     if (t.id === payload.id) {
//       return {
//         ...t,
//         title: payload.title !== undefined ? payload.title : t.title,
//         version: payload.version !== undefined ? payload.version : t.version,
//         effectiveDate: payload.effectiveDate !== undefined ? payload.effectiveDate : t.effectiveDate,
//         scenario: payload.scenario !== undefined ? payload.scenario : t.scenario,
//         changeType: payload.changeType !== undefined ? payload.changeType : t.changeType,
//         needsReacceptance: payload.changeType === "Material" ? "Yes" : "No",
//         fileName: payload.file ? payload.file.name : t.fileName,
//       };
//     }
//     return t;
//   });

//   return {
//     status: 200,
//     data: {
//       message: "Terms version updated successfully",
//     },
//   };
// };

// export const publishTermsVersionAPI = async (id: number) => {
//   // Commented API call:
//   // return axios.post(`/compliance/terms/${id}/publish/`);

//   dummyTerms = dummyTerms.map((t) => {
//     if (t.id === id) {
//       return {
//         ...t,
//         status: true, // true = published
//       };
//     }
//     return t;
//   });

//   return {
//     status: 200,
//     data: {
//       message: "Terms version published successfully",
//     },
//   };
// };

// export const deleteTermsVersionAPI = async (id: number) => {
//   // Commented API call:
//   // return axios.delete(`/compliance/terms/${id}/`);

//   dummyTerms = dummyTerms.filter((t) => t.id !== id);

//   return {
//     status: 200,
//     data: {
//       message: "Terms version deleted successfully",
//     },
//   };
// };

// export const duplicateTermsVersionAPI = async (payload: any) => {
//   // Commented API call:
//   // return axios.post(`/compliance/terms/duplicate/`, payload);

//   const original = dummyTerms.find((t) => t.id === payload.id);
//   const newId = dummyTerms.length > 0 ? Math.max(...dummyTerms.map((t) => t.id)) + 1 : 1;

//   const duplicatedTerm = {
//     id: newId,
//     version: payload.version || (original ? `${original.version}_dup` : "New Version"),
//     title: payload.title || (original ? `${original.title} (Duplicate)` : "Customer Terms and Conditions"),
//     effectiveDate: payload.effectiveDate || new Date().toLocaleDateString(),
//     changeType: payload.changeType || (original ? original.changeType : "Material"),
//     needsReacceptance: (payload.changeType === "Material" ? "Yes" : "No") as "Yes" | "No",
//     status: false, // Duplicated versions are drafts by default
//     createdBy: "admin@livis.com",
//     scenario: payload.scenario || (original ? original.scenario : "Clickwrap"),
//     fileName: original ? original.fileName : null,
//   };

//   dummyTerms = [duplicatedTerm, ...dummyTerms];

//   return {
//     status: 200,
//     data: {
//       message: "Terms version duplicated successfully",
//       term: duplicatedTerm,
//     },
//   };
// };

import { axios } from "../helpers/axios";

const BASE = "terms";

// 1. List all terms versions
export const getTermsRepositoryAPI = (filters: any): Promise<any> => {
  const params: Record<string, any> = {};

  if (filters?.statusFilter && filters.statusFilter !== "all")
    params.status = filters.statusFilter;          // "active" | "draft"

  if (filters?.typeFilter && filters.typeFilter !== "all")
    params.change_type = filters.typeFilter;        // "material" | "minor"

  if (filters?.current  != null) params.current  = filters.current;
  if (filters?.limit_to != null) params.limit_to = filters.limit_to;

  return axios.get(`${BASE}/versions/`, { params });
};

// 2. Create a new terms version (multipart/form-data)
export const createNewTermsVersionAPI = (payload: any): Promise<any> => {
  const formData = new FormData();
  formData.append("document_file", payload.file);
  formData.append("version", payload.version);
  formData.append("effective_date", payload.effectiveDate);
  formData.append("title", payload.title);
  formData.append("scenario", payload.scenario);
  if (payload.changeType)
    formData.append("change_type", payload.changeType.toLowerCase());
  if (payload.requiresReacceptance !== undefined)
    formData.append(
      "requires_reacceptance",
      String(payload.requiresReacceptance)
    );
  if (payload.notes) formData.append("notes", payload.notes);
  return axios.post(`${BASE}/versions/create/`, formData, {
    validateStatus: (status) => status >= 200 && status < 300,
  });
};

// 3. Activate (publish) a terms version
export const publishTermsVersionAPI = (id: string | number): Promise<any> => {
  return axios.post(`${BASE}/versions/activate/`, { id: String(id) });
};

// 4. Deactivate a terms version
export const deactivateTermsVersionAPI = (
  id: string | number
): Promise<any> => {
  return axios.post(`${BASE}/versions/deactivate/`, { id: String(id) });
};

// 5. Delete a terms version
export const deleteTermsVersionAPI = (id: string | number): Promise<any> => {
  return axios.post(`${BASE}/versions/delete/`, { id: String(id) });
};

// 6. Edit a terms version (JSON or multipart if file is provided)
export const updateTermsVersionAPI = (payload: any): Promise<any> => {
  if (payload.file) {
    const formData = new FormData();
    formData.append("id", String(payload.id));
    formData.append("document_file", payload.file);
    if (payload.title) formData.append("title", payload.title);
    if (payload.effectiveDate)
      formData.append("effective_date", payload.effectiveDate);
    if (payload.changeType)
      formData.append("change_type", payload.changeType.toLowerCase());
    if (payload.requiresReacceptance !== undefined)
      formData.append(
        "requires_reacceptance",
        String(payload.requiresReacceptance)
      );
    if (payload.notes) formData.append("notes", payload.notes);
    return axios.post(`${BASE}/versions/edit/`, formData);
  }

  const body: Record<string, any> = { id: String(payload.id) };
  if (payload.title) body.title = payload.title;
  if (payload.effectiveDate) body.effective_date = payload.effectiveDate;
  if (payload.changeType) body.change_type = payload.changeType.toLowerCase();
  if (payload.requiresReacceptance !== undefined)
    body.requires_reacceptance = payload.requiresReacceptance;
  if (payload.notes) body.notes = payload.notes;
  return axios.post(`${BASE}/versions/edit/`, body);
};

// 7a. Get org compliance profiles (all orgs — superuser)
export const getOrgComplianceAPI = (filters: {
  search?: string;
  contract_type?: string;
  terms_status?: string;
  sort_by?: string;
  current?: number;
  limit_to?: number;
}): Promise<any> => {
  const params: Record<string, any> = {};

  if (filters?.search)         params.search         = filters.search;
  if (filters?.contract_type)  params.contract_type  = filters.contract_type;

  // Notice the mapping here: UI passes 'terms_status', but API expects 'status'
  if (filters?.terms_status)   params.status         = filters.terms_status;

  if (filters?.sort_by)        params.sort_by        = filters.sort_by;

  // CHANGE 10: use != null instead of truthiness so these are always sent
  // when explicitly provided — guards against falsy values like 0 being dropped
  if (filters?.current  != null) params.current  = filters.current;
  if (filters?.limit_to != null) params.limit_to = filters.limit_to;

  return axios.get(`${BASE}/org_profile/`, { params });
};

// 7b. Create / update an org terms profile
export const createOrgProfileAPI = (payload: any): Promise<any> => {
  return axios.post(`${BASE}/org_profile/`, payload);
};

// 8. Get terms status for the current user / org
export const getTermsStatusAPI = (): Promise<any> => {
  return axios.get(`${BASE}/status/`);
};

// 9. Accept terms
export const acceptTermsAPI = (payload: any): Promise<any> => {
  return axios.post(`${BASE}/accept/`, payload);
};

// 10. Decline terms
export const declineTermsAPI = (payload: any): Promise<any> => {
  return axios.post(`${BASE}/decline/`, payload);
};

// 11. Terms acceptance history
export const getTermsHistoryAPI = (filters: any): Promise<any> => {
  const params: Record<string, any> = {};
  if (filters?.organization) params.organization = filters.organization;
  if (filters?.search)       params.search       = filters.search;   
  if (filters?.current)      params.current      = filters.current;
  if (filters?.limit_to)     params.limit_to     = filters.limit_to;
  return axios.get(`${BASE}/history/`, { params });
};

// 12. Export terms history as CSV
export const exportTermsHistoryAPI = (organization?: string): Promise<any> => {
  const params: Record<string, any> = {};
  if (organization) params.organization = organization;
  return axios.get(`${BASE}/export/`, { params });
};

export const uploadPhysicalMsaAPI = (payload: any): Promise<any> => {
  return axios.post(
    `${BASE}/org_profile/`,
    {
      organization: payload.orgId,
      legal_entity_name: payload.legalEntityName,
      contract_type: "signed_msa",
    },
    {
      validateStatus: (status) => status >= 200 && status < 300,
    }
  );
};

// Duplicate a terms version — fetches original then creates a new version from it
export const duplicateTermsVersionAPI = (payload: any): Promise<any> => {
  const formData = new FormData();
  formData.append("version", payload.version);
  formData.append("effective_date", payload.effectiveDate);
  formData.append("title", payload.title);
  formData.append("scenario", payload.scenario);
  formData.append(
    "change_type",
    (payload.changeType || "material").toLowerCase()
  );
  if (payload.notes) formData.append("notes", payload.notes);
  return axios.post(`${BASE}/versions/create/`, formData);
};

// ADD this new function (keep uploadPhysicalMsaAPI for reference but it won't be called anymore)

export const uploadMsaDomainSpecificAPI = (payload: {
  organization: string;
  document_file: File;
  version: string;
  effective_date: string;
  title: string;
  notes?: string;
}): Promise<any> => {
  const formData = new FormData();
  formData.append("organization", payload.organization);
  formData.append("document_file", payload.document_file);
  formData.append("version", payload.version);
  formData.append("effective_date", payload.effective_date);
  formData.append("title", payload.title);
  if (payload.notes) formData.append("notes", payload.notes);
  return axios.post(`${BASE}/msa/upload/`, formData, {
    validateStatus: (status) => status >= 200 && status < 300,
  });
};

// Fetch MSA domains (organizations with signed_msa)
export const getMsaDomainsAPI = (): Promise<any> => {
  return axios.get(`${BASE}/msa/domains/`);
};

export const acknowledgeMinorTermsAPI = (payload: {
  terms_version: string;
  button_text?: string;
  acceptance_method?: string;
}): Promise<any> => {
  return axios.post(`${BASE}/acknowledge_minor/`, payload); // ✅ POST with body, not GET with params
};

// 13. Check version name uniqueness
export const checkUniqueVersionAPI = (
  version: string,
  type: "clickwrap" | "msa",
  organization?: string
): Promise<any> => {
  const params: Record<string, string> = { version, type };
  if (organization) params.organization = organization;
  return axios.get(`${BASE}/versions/check/`, {
    params,
    suppressAlerts: { statusCode: [422] },
  } as any);
};
